import Navbar from './globalComponents/Navbar'
import Footer from './globalComponents/Footer'
import { Outlet } from 'react-router-dom'

const layout = () => {
  return (
    <div className="flex flex-col bg-white overflow-hidden">
    {/* Common Header */}
    <Navbar/>
    <main className="flex flex-col w-full">
        <Outlet/>
    </main>
    <Footer/>
</div>
  )
}

export default layout
